import React from 'react';
import classnames from "classnames";
import Status from "../Shared/icons/Status";

function List(props) {
    const status = props.status;
    const statusClass = "vacature-tile__status--" + status;
    const text = props.text;

    return (
        <div className="card card--white card-header-secondary  vacature-tile-alt link-hover card-border col-mb">
            <div className="card-body d-flex flex-column py-2 px-8">
                <div className="body text-secondary">
                    {status && text &&
                        <div
                            className={classnames("vacature-tile__status d-flex align-items-center py-4", statusClass)}>

                            <div className="status-icon">
                                <Status/>
                            </div>

                            <div className="pl-8 status-text">
                                <div dangerouslySetInnerHTML={{__html: text}}></div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default List;